module.exports = __webpack_public_path__ + "img/Flag_of_Qatar.a9bfbf2a.svg";